import { useCallback, useEffect, useState } from 'react'

import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { OrgType } from 'app/dataTypes/org'
import { subscibeTo } from 'app/common/data-box-store'
import { OrderByClassesDetailsGroup } from 'app/dataTypes/reports/data/common/ordersByClasses'

import {
  defaultOrgsDataReceiver,
  defaultOrgsSelection,
  orgTypesFilterSelection,
  orgsFilter,
  orgsFilterSelection,
  orderByClassesGroupFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = {
  id: string
  pending: boolean
}

export const OrgsFilter = ({ id, pending }: Props) => {
  const [multipleSelection, setMultipleSelection] = useState(true)

  const handleOrgTypesFilter = useCallback((data: OrgType[]) => {
    if (data.length === 1) {
      orgsFilter.addDataReceiver(defaultOrgsDataReceiver)
      orgsFilter.dataReceive()
      return
    }
    orgsFilter.resetToDefault()
  }, [])

  const handleDetailsGroupFilter = useCallback((data: OrderByClassesDetailsGroup) => {
    if (data === OrderByClassesDetailsGroup.ByComplexesAndAllowances) {
      setMultipleSelection(false)
      return
    }
    setMultipleSelection(true)
  }, [])

  useEffect(() => {
    const unsubsribeOrgType = subscibeTo<OrgType[]>(
      orgTypesFilterSelection.id,
      handleOrgTypesFilter,
    )

    const unsubsribeDetailsGroup = subscibeTo<OrderByClassesDetailsGroup>(
      orderByClassesGroupFilterSelection.id,
      handleDetailsGroupFilter,
    )
    return () => {
      unsubsribeOrgType()
      unsubsribeDetailsGroup()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PlainItemsSelectorBox
      id={id}
      label="Заведение"
      header="Выбор заведения"
      dataBoxData={orgsFilter}
      dataBoxSelection={orgsFilterSelection}
      pleaseSelectText="Нет данных"
      disabled={pending}
      multiple={multipleSelection}
      selectedAllOnEmptySelection={multipleSelection}
      defaultSelection={multipleSelection ? defaultOrgsSelection : undefined}
    />
  )
}
